<template>
  <SocioDialog
    v-model="needRefresh"
    :title="t('title')"
    :confirm-text="t('refresh')"
    confirm-icon="mdi-refresh"
    :cancel-text="t('later')"
    data-testid="app-refresh-modal"
    @confirm="update"
    @cancel="dismiss"
  >
    <template #textSlot>
      <p data-testid="app-refresh-message">{{ t("message") }}</p>
    </template>
  </SocioDialog>
</template>

<script setup>
  import { useRegisterSW } from "virtual:pwa-register/vue";
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();
  const { needRefresh, updateServiceWorker } = useRegisterSW();
  const update = () => updateServiceWorker(true);

  const dismiss = () => {
    needRefresh.value = false;
  };
</script>

<i18n>
{
  "fr": {
    "title": "Nouvelle version disponible",
    "message": "Une nouvelle version de Vigico est disponible. Rafraîchissez la page pour en bénéficier.",
    "refresh": "Rafraîchir",
    "later": "Plus tard"
  },
  "en": {
    "title": "New version available",
    "message": "A new version of Vigico is available. Refresh the page to get the latest updates.",
    "refresh": "Refresh",
    "later": "Later"
  }
}
</i18n>
